import React, {useState, useEffect, useImperativeHandle, forwardRef} from 'react';
import {AutoComplete, message, Select} from 'antd';
import { WWMethods, WWUtils } from "@/tools";

const DeviceSearch = ({ onChange }, ref) => {
    const [searchValue, setSearchValue] = useState(null);
    const [options, setOptions] = useState([]);
    //暴露给父组件的方法
    useImperativeHandle(ref, () => ({
        resetSearchValue: (value) => {
            setSearchValue((value));
        }
    }));

    //当输入长度大于2时触发模糊搜索获取设备列表
    const handleSearch = (value) => {
        let url = WWMethods.getApiUrl("deviceSearch");
        url += "?count=" + 20;
        url += value ? "&content=" + value : "";
        if (value && value.toString().length >= 2) {
            WWUtils.fetch(url, 'GET', (data) => {
                if (data.code === 0) {
                    setOptions(data.data);
                } else {
                    message.error(data.message);
                }
            });
        }
    };
    //遍历设备列表设置为option
    const deviceOption = Array.isArray(options)
        ? options.map((item) => {
            let content
            if(item.imei){
                content = item.carCode + " (IMEI:" + item.imei + ")";
            }else {
                content = item.carCode
            }
            let value = item.carId
            return (
                <AutoComplete.Option key={value} value={value} label={content}>
                    {content}
                </AutoComplete.Option>
            );
        })
        : null;

    const handleChange = (value) => {
        setSearchValue(value);
    };
    const handleSelect= (value,option) => {
        if(option){
            setSearchValue(option.label);
        }
        if (onChange) {
            onChange(value);
        }
    };


    return (
        <Select
            showArrow={false}
            allowClear
            showSearch
            className={"h30 ft13"}
            onClear={() =>{
                handleSelect("")
            }}
            onBlur={() => {
                setOptions([]);
                setSearchValue(searchValue?searchValue:null);
            }}
            value={searchValue}
            placeholder={Strings.inputMachineCodeOrImei || "请输入机械编号/设备号"}
            onSearch={handleSearch}
            onChange={handleChange}
            onSelect={handleSelect}
            filterOption={false}
            notFoundContent={null}
            style={{ width: 240 }}
        >
            {deviceOption}
        </Select>
    );
};

export default forwardRef(DeviceSearch);
